/**
 * Standard API envelope response from the TrackDox backend.
 */
export interface ApiResponse<T> {
  status: 'success' | 'error';
  data: T | null;
  message: string;
  errors: Array<{ field: string; detail: string }>;
}

/**
 * Cursor-based paginated response wrapper.
 */
export interface PaginatedResponse<T> {
  results: T[];
  next_cursor: string | null;
  previous_cursor: string | null;
  page_size: number;
}

/**
 * Structured API error with status code and field-level validation errors.
 */
export class ApiError extends Error {
  public readonly statusCode: number;
  public readonly fieldErrors: Array<{ field: string; detail: string }>;

  constructor(
    statusCode: number,
    message: string,
    fieldErrors: Array<{ field: string; detail: string }> = [],
  ) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.fieldErrors = fieldErrors;
  }
}
